const pluralize = (word, count) => `${word}${parseInt(count, 10) > 1 ? 's' : ''}`;

const periodText = period =>
  ({
    1: 'day',
    2: 'week',
    3: 'month'
  })[period] || '';

/**
 * Given frequency object should return stirng representation 1_1 => 1 week
 */
module.exports = function ({ every, period }) {
  return `${every} ${pluralize(periodText(period), every)}`;
};
